module.exports = __webpack_public_path__ + "static/time-of-arrival_acrylic-on-canvas-59x79.5in-481148d7f5f6eeff3e8e396ca5849119.jpg";